import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import { fsfn_sports } from 'projectSpecific/sports/functions/fbSportsFuntions'
import React, { useContext, useMemo, useState } from 'react'
import { _fetchModes, _mediaModes, _rightModes_mdu } from './MatchDataUpdate'
import { _sdm } from '../dashboard/SportsDashboard'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { _sportCollections } from 'projectSpecific/sports/cnr/reducers/SportsSidebarReducer'
import useGoogleSports from 'projectSpecific/sports/useHelpers/useGoogleSports'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useMatches } from 'react-router-dom'
import { useFunctions } from 'global/cnr/contexts/useHelpers/useFunctions'
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths'
import { collection, getDocs, where } from 'firebase/firestore'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import { callFunctionDirect } from 'global/functions/fbAll'

const _openModes = {
  database: 'database',
  realtimeDb: 'realtimeDb',
  googleSheets: 'googleSheets',
  media: 'media',
}

const useMediaDataOptions = ({
  currentMenuKey,
  handleMode_left,
  linkValues,
  mediaUrl,
  setMode_right,
  sportsData_handlers,
  sportsDataMode,
  gls_score
}) => {

  const { fn_cls } = useFunctions()

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns, appUser_fns } = fns
  const { mainDb } = app_state
  const { mainFunctions, app_alts } = app_state

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { gameScoringType, currentSeason_info, sportSettings_info } = sportsSeason_state ?? {}

  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const [mediaResults, set_mediaResults] = useState()
  const [fetchingFn, setFetchingFn] = useState()

  const { handleGet_gsMatches, fetching } = useGoogleSports({
    currentMenuKey,
    gameScoringType,
    sportsDataMode,
  })

  const handleGoogleSearch = (e, opts) => {
    handleMode_left(e)

    const cb = (matchResultsInfo) => {
      const _forPlayoffs = opts?.fetchMode === 'playoffResults'
      set_mediaResults({ matchResultsInfo, _forPlayoffs })
      sportsData_handlers.handleAmmend_gsMatches(matchResultsInfo, _forPlayoffs)
    }

    handleGet_gsMatches({ opts, callback: cb })
  }

  const handleAmmend = (e, opts) => {
    e && e.stopPropagation()
    const updatedMatches = _.chain(matches_flat_filtered)
      .filter(match => _.has(match, 'old.startDate'))
      .map(match => _.set(_.clone(match), 'startDate', _.get(match, 'old.startDate')))
      .value();
    const updatedMatches_gs = _.chain(matches_gs)
      .filter(match => _.has(match, 'old.startDate'))
      .map(match => _.set(_.clone(match), 'startDate', _.get(match, 'old.startDate')))
      .value();
  }

  const handleTrigger_gsScoreFunction = (e) => {
    e && e.stopPropagation()
    const cb = (res) => {
      console.log('res', res)
      setFetchingFn(false)
    }
    setFetchingFn(true)
    fn_cls.getSportsDataGlsScores(gls_score, cb)
  }

  const handleTrigger_activeGlsItems = async (e) => {
    e && e.stopPropagation()

    // console.log('activeItems1', await getActiveGlsItems(database_fns, pathViews))
    console.log('activeItems2', await getActiveGlsItems2(mainDb, pathViews))

    const cb = (res) => {
      console.log('cb handleTrigger_activeGlsItems', res)
      setFetchingFn(false)
    }
    setFetchingFn(true)
    const sportsYear = 2026
    const _matchDateResultsName = 'gsResults'
    // fn_cls.getActiveGs(linkValues?.googleSheetsId, `${linkValues?.scoresSheet} ${latestSeason}`, cb)
    fn_cls.getActiveGlsItems(pathViews, cb)
  }

  const handleTrigger_testUpdateScoresFromPubSub = async (e) => {
    e && e.stopPropagation()

    const cb = (res) => {
      console.log('cb', res)
      setFetchingFn(false)
    }
    setFetchingFn(true)
    fn_cls.testUpdateScoresFromPubSub(pathViews, cb)
  }

  const handleTrigger_test = async (e) => {
    e && e.stopPropagation()

    const response = await callFunctionDirect('testMemory', {}, mainFunctions);
    const { result: m } = response ?? {}
    console.log(`MEMORY`, {
      rssMB: Math.round(m.rss / 1024 / 1024),
      heapUsedMB: Math.round(m.heapUsed / 1024 / 1024),
      heapTotalMB: Math.round(m.heapTotal / 1024 / 1024),
      externalMB: Math.round(m.external / 1024 / 1024),
    });

    const cb = (res) => {
      setFetchingFn(false)
    }
    setFetchingFn(true)
    fn_cls.simpleTest(cb)
  }

  const handleTrigger_meRegtest = async (e) => {
    e && e.stopPropagation()
    const data = {
      googleSheetsId: "149TOfg68NaqqiFEx9VhHC9O7j8xjbDPoULuxRqQeY8U",
      name: "Players",
      values: [
        { firstName: "John", lastName: "Smith" },
        { firstName: "Jane", lastName: "Doe" }
      ]
    }
    const payload = {
      data: {
        googleSheetsId: "149TOfg68NaqqiFEx9VhHC9O7j8xjbDPoULuxRqQeY8U",
        name: "Players",
        values: [
          { firstName: "John", lastName: "Smith" },
          { firstName: "Jane", lastName: "Doe" }
        ]
      }
    };
    console.log('data', data)
    console.log('payload', payload)
    const response = await callFunctionDirect('meReg_createGsTab', data, mainFunctions);
    const { result: m } = response ?? {}
    const cb = (res) => {
      setFetchingFn(false)
    }
    setFetchingFn(true)
    fn_cls.simpleTest(cb)
  }

  const handleGoogleSearch_rankings = (e) => {
    handleMode_left(e)
    const gsValues = _.clone(linkValues)
    gsValues.googleSheetsId = linkValues.rankingsGoogleSheetsId
    gsValues.sheetName = linkValues.rankingsSheet
    if (sportsData_handlers) {
      sportsData_handlers.handleStartUpdate()
      sportsData_handlers.handleGet_gsRankings(gsValues, currentYear, sportsKey)
    }
  }

  const btn_itemRight = (items, icon_sub, caption, rightMode, disabled, fl) => {
    const occ = (a, b) => {
      const rm = b?.rightMode ? b?.rightMode : a?.rightMode
      setMode_right(rm)
    }
    items.push({ caption, oc: occ, color: 'blue', icon: icon_sub, disabled, opts: { rightMode: rightMode } })
  }

  const item_itemOpen = (items, icon_sub, openMode, disabled) => {
    const occ = (e, opts) => {
      handleMode_left(e)
      switch (opts.openMode) {
        case _openModes.database:
          // pks_matches_seasonal
          openExternal.firebaseDbDirect(pathViews, [_sportCollections._matches_seasonal])
          break;
        case _openModes.realtimeDb:
          openExternal.realtimeDb(pathViews)
          break;
        case _openModes.googleSheets:
          openExternal.googleSheets(linkValues.googleSheetsId)
          break;
        case _openModes.media:
          window.open(mediaUrl, '_blank')
          break;
      }
    }
    items.push({ caption: _.startCase(openMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { openMode: openMode } })
  }

  const item_itemSearch = (items, icon_sub, fetchMode, disabled) => {
    const occ = (e, opts) => {
      handleGoogleSearch(e, opts)
    }
    items.push({ caption: _.startCase(fetchMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { fetchMode: fetchMode } })
  }

  const item_itemMediaSearch = (items, icon_sub, fetchMode, disabled) => {
    const occ = (e, opts) => {
      handleMediaSearch_results(e, opts)
    }
    items.push({ caption: _.startCase(fetchMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { fetchMode: fetchMode } })
  }

  const items_ammend = () => {
    const items = []
    // items.push({ header: 'Adjust', db: true, da: true, icon: 'refresh', })
    items.push({ caption: 'Revert to Old Date', oc: handleAmmend, color: 'teal', fl: true, opts: { rightMode: _rightModes_mdu.exportResults } })
    return items
  }

  const items_scores = () => {
    const items = []
    let icon_sub = 'arrow right';
    // items.push({ header: 'Scores (' + currentYear + ')', db: true, da: true, icon: 'save', color: 'blue' })
    btn_itemRight(items, icon_sub, 'Update Scores', _rightModes_mdu.confirmScores)
    items.push({ caption: 'Trigger GS Score Function', oc: handleTrigger_gsScoreFunction, color: 'teal', fl: true, icon: 'arrow right' })
    items.push({ caption: 'Get Active GLS', oc: handleTrigger_activeGlsItems, color: 'teal', fl: true, icon: 'arrow right' })
    items.push({ caption: 'Trigger Pub Sub ', oc: handleTrigger_testUpdateScoresFromPubSub, color: 'teal', fl: true, icon: 'arrow right' })
    items.push({ caption: 'Trigger Test', oc: handleTrigger_test, color: 'teal', fl: true, icon: 'arrow right' })
    items.push({ caption: 'Trigger Reg Test!!!', oc: handleTrigger_meRegtest, color: 'teal', fl: true, icon: 'arrow right' })
    return items
  }

  const items_backup = () => {
    const items = []
    let icon_sub = 'arrow right';
    // items.push({ header: 'Backup (' + currentYear + ')', db: true, da: true, icon: 'save', color: 'blue' })
    btn_itemRight(items, icon_sub, 'Backup Matches', _rightModes_mdu.backupMatches)
    btn_itemRight(items, icon_sub, 'Backup Playoff Matches', _rightModes_mdu.backupPlayoffMatches)
    btn_itemRight(items, icon_sub, 'Backup Scores', _rightModes_mdu.backupScores)
    return items
  }

  /**
   * 
   * @returns a list of items that will appear within a menu
   */
  const items_search = () => {

    const items = []
    const items_external = []
    const items_s = []
    const items_media = []

    let icon_ext;
    let icon_search;

    switch (sportsDataMode) {
      case _sdm.sports.seasonResults:
        icon_ext = 'external alternate'
        item_itemOpen(items_external, icon_ext, _openModes.database)
        item_itemOpen(items_external, icon_ext, _openModes.realtimeDb)
        item_itemOpen(items_external, icon_ext, _openModes.googleSheets)
        item_itemOpen(items_external, icon_ext, _openModes.media)

        if (linkValues.scoresSheet) {
          icon_search = 'search'
          item_itemSearch(items_s, icon_search, _fetchModes.seasonResults)
          item_itemSearch(items_s, icon_search, _fetchModes.playoffResults)
          item_itemSearch(items_s, icon_search, _fetchModes.mediaResults)
          item_itemSearch(items_s, icon_search, _fetchModes.mediaPlayoffResults)
          item_itemSearch(items_s, icon_search, _fetchModes.wpialResults)
        }

        if (mediaUrl || 1 === 1) {
          item_itemMediaSearch(items_media, icon_search, _mediaModes.results)
          item_itemMediaSearch(items_media, icon_search, _mediaModes.playoffResults)
          // items.push({ caption: 'Date Results', oc: handleMediaSearch_dates, color: 'blue', fl: true })
          // items.push({ caption: 'Playoff Results', oc: handleMediaSearch_playoffs, color: 'blue', fl: true, icon: 'search' })
          // items.push({ caption: 'Refresh Playoff Results', oc: handleRefreshSearch_playoffs, color: 'blue', fl: true })
        }
        break;

      case _sdm.sports.seasonRankings:
        items.push({ caption: 'Search Google Sheets Rankings', oc: handleGoogleSearch_rankings, color: 'blue', icon: 'search', fl: true })
      // items.push({ caption: 'Open Google Sheets', oc: handleOpenGoogleSheets, color: 'orange', icon: appIconTypes.externalAlternate, fl: true })

      default:
        break;

      // nothing
    }
    return { items_external, items_s, items_media }
  }

  const items_exportTo = () => {
    const items = []
    let icon_sub = 'cloud upload';
    btn_itemRight(items, icon_sub, 'Results', _rightModes_mdu.exportResults)
    btn_itemRight(items, icon_sub, 'Playoff Results', _rightModes_mdu.exportPlayoffResults)
    btn_itemRight(items, icon_sub, 'Media Results', _rightModes_mdu.exportResultsMedia)
    btn_itemRight(items, icon_sub, 'Media Playoff Results', _rightModes_mdu.exportPlayoffResultsMedia)
    btn_itemRight(items, icon_sub, 'Standings', _rightModes_mdu.exportStandings)
    return items
  }

  const matchDataOptions = useMemo(() => {
    const { items_external, items_s, items_media } = items_search()
    const allItems = {
      search: { items: items_s, caption: 'Search', icon: 'search', iconColor: 'yellow' },
      media: { items: items_media, caption: 'Media', icon: 'newspaper outline', iconColor: 'purple' },
      export: { items: items_exportTo(), caption: 'Export', icon: 'cloud download', iconColor: 'pink' },
      ammend: { items: items_ammend(), caption: 'Ammend', icon: 'edit outline', iconColor: 'blue' },
      scores: { items: items_scores(), caption: 'Scores', icon: 'list ol', iconColor: 'black' },
      openExternal: { items: items_external, caption: 'External', icon: 'external alternate', iconColor: 'orange' },
      backup: { items: items_backup(), caption: 'Backup', icon: 'database', iconColor: 'teal' },
    }
    return allItems
  })

  return { matchDataOptions, mediaResults, fetching: fetching || fetchingFn }
}

export default useMediaDataOptions

const getActiveGlsItems = async (database_fns, pathViews) => {

  const refPath = createRefPath_event(pathViews, ['_gls_scores'])

  const rez = await new Promise((resolve) => {
    database_fns.get_data({ refPath, callback: resolve })
  })

  const allItems = []

  if (rez) {
    _.forEach(rez, (item) => {
      const { gls_scores } = item
      const activeGlsItems = _.filter(gls_scores, { allowScheduledScoreUpdateFromGs: true })
      _.forEach(activeGlsItems, (_item) => {
        allItems.push(_item)
      })
    })
  }

  return allItems
}

const getActiveGlsItems2 = async (mainDb, pathViews, googleSheetsId) => {

  const refPath = createRefPath_event(pathViews, ['_gls_scores'])
  const colRef = collection(mainDb, refPath)
  const snapshot = await getDocs(colRef)

  const allItems = []

  for (const doc of snapshot.docs) {
    const { parentKeys, gls_scores } = doc.data()

    if (googleSheetsId) {
      const item = _.find(gls_scores, { googleSheetsId, allowScheduledScoreUpdateFromGs: true })
      if (item) return { ...item, parentKeys }
    } else {
      _.forEach(_.filter(gls_scores, { allowScheduledScoreUpdateFromGs: true }), (_item) => {
        allItems.push({ ..._item, parentKeys })
      })
    }
  }

  return googleSheetsId ? null : allItems

}